import { render, staticRenderFns } from "./addenseignant.vue?vue&type=template&id=0ab96c21&"
import script from "./addenseignant.vue?vue&type=script&lang=js&"
export * from "./addenseignant.vue?vue&type=script&lang=js&"
import style0 from "./addenseignant.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports